import { createSelector } from 'reselect';

export const isAuthenticated = createSelector(
  [s => s],
  s => !!s.auth?.token?.token,
);

export const isAdmin = createSelector(
  [s => s],
  s => s.auth?.profile?.role === 'admin',
);

export const isVerified = createSelector(
  [s => s],
  s => !!s.auth?.profile?.verifiedAt,
);
